// Row actions menu (the "⋮" button in tables). Radix DropdownMenu.
// items: [{ label, onClick, icon, danger, disabled, hidden }]
import { DropdownMenu } from "radix-ui";
import { MoreVertical } from "lucide-react";
import { cn } from "./cn";

export function ActionMenu({ items = [], label = "Actions", trigger, align = "end" }) {
  const visible = items.filter((i) => i && !i.hidden);
  if (!visible.length) return null;
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>
        {trigger || (
          <button type="button" aria-label={label} className="grid size-8 place-items-center rounded-lg text-muted hover:bg-black/[0.045] hover:text-fg data-[state=open]:bg-black/[0.045]">
            <MoreVertical className="size-4" />
          </button>
        )}
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align={align} sideOffset={4} className="z-[1400] min-w-44 rounded-xl border border-line bg-panel p-1 shadow-pop">
          {visible.map((item, i) => {
            const Icon = item.icon;
            return (
              <DropdownMenu.Item
                key={item.label + i}
                disabled={item.disabled}
                onSelect={() => item.onClick?.()}
                className={cn(
                  "flex h-9 cursor-pointer items-center gap-2 rounded-md px-2.5 text-[13px] outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-45 data-[highlighted]:bg-black/[0.045]",
                  item.danger ? "text-danger" : "text-text",
                )}
              >
                {Icon && <Icon className="size-4 shrink-0" />}
                {item.label}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
